const Header = () => {
    return (
        <header className="App-header">
            The Weight On Other Planets
        </header>
    )
}

export default Header;